import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'found';

import Main from 'ripple/Containers/Main';
// import { isPast } from 'date-fns';
import RMPSChardonnayChat from './rmpschardonnaychat';
import SvedkaHalloween from './svedkahalloween';
import RMPSSpiritsBarrelSaged from './rmpsspiritsbarrelsaged';

const SlugViewMap = {
  rmpschardonnaychat: RMPSChardonnayChat,
  svedkahalloween: SvedkaHalloween,
  rmpsspiritsbarrelsaged: RMPSSpiritsBarrelSaged,
};

const EventView = ({ viewer }) => {

  const {
    match: {
      params: { eventSlug },
    },
    router,
  } = useRouter();
  const Comp = SlugViewMap[eventSlug];
  const [canRender, setCanRender] = useState(false);
  const navigateToApplication = useCallback(
    () => {
      router.push('/discover/events');
    },
    [router, eventSlug],
  );

  useEffect(() => {
    if (['rmpschardonnaychat', 'svedkahalloween', 'rmpsspiritsbarrelsaged'].indexOf(eventSlug) === -1) {
      router.push(`/events/${eventSlug}`);
    } else {
      setCanRender(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Main
      title='Home'
      viewer={viewer}
      padContent={false}
      padContainerBottom={false}
    >
      {canRender && <Comp navigateToApplication={navigateToApplication} />}
    </Main>
  );
};

EventView.propTypes = {
  relay: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default EventView;
